import React, { Fragment, useEffect } from 'react'
import Footer from 'src/components/footer'
import TopBarSearch from 'src/components/top_bar/TopBarSearch'
import TopBar from 'src/components/top_bar/TopBar'
import withStyles from 'react-jss'
import styles from './PageProduit.styles'
import { Grid } from 'react-bootstrap'
import Titre1 from 'src/components/font/Titre1'
import { Link } from 'react-router-dom'
import routes from 'src/routing/routes'
import Titre2 from 'src/components/font/Titre2'
import Titre3 from 'src/components/font/Titre3'
import { Helmet } from 'react-helmet'
import Spinner from '../../../../../components/Spinner'
import PubContainer from '../../../../../components/PubContainer'
import { responsiveAd, smBannerAd } from '../../../../../config/dataConf'

const PageProduit = ({
  classes,
  data,
  category,
  title,
  description,
  loading
}) => {
  let adsInserted = 0
  let producerIndex = 0

  const insertPub = index => {
    if ((index + 1) % 10 === 0 && adsInserted < 10) {
      adsInserted++
      return (
        <Fragment>
          <hr />
          <PubContainer scriptPubCore={smBannerAd} className={classes.ads} />
          <hr />
        </Fragment>
      )
    }
    return null
  }

  return (
    <div className={classes.wrapperAll}>
      <Helmet>
        <title>
          {title ? title : `${category} : Vente directe producteur`}
        </title>
        <meta
          name='description'
          content={
            description
              ? description
              : `${category} en vente directe producteur sur Acheter à la Source. Découvrez tous les produits proches de chez vous par région !`
          }
        />
      </Helmet>

      <Grid fluid className={classes.wrapperWithoutFooter}>
        <div className='visible-xs-block'>
          <TopBar />
        </div>
        <div className='hidden-xs'>
          <TopBarSearch bleu />
        </div>
        <Grid className={classes.regionContainer}>
          <PubContainer scriptPubCore={smBannerAd} />
          <Titre1>{`${category} en vente directe producteur`}</Titre1>
          <hr className={classes.hrTitle} />

          {!loading ? (
            data &&
            data.regionsWithProducts.map((regionWithProducts, i) => {
              const region = regionWithProducts.region
              const products = regionWithProducts.products
              return products.length > 0 ? (
                <div key={i}>
                  <Titre1 component='h2'>{region.name}</Titre1>
                  {products.map((product, j) => (
                    <Fragment key={j}>
                      {insertPub(producerIndex++)}
                      <div className={classes.productContainer}>
                        <img
                          src={
                            product.photosProduct.length > 0
                              ? product.photosProduct[0].cloudPath
                              : '/img/no_photo.jpg'
                          }
                          alt={product.name}
                          className={classes.imageProduct}
                        />
                        <div className={classes.texteProduit}>
                          <Titre2 component='p'>
                            <Link
                              to={routes.ficheProduit.replace(
                                ':idProduct(\\d+)',
                                product.id
                              )}
                              className={classes.link}
                            >
                              {product.name}
                            </Link>
                          </Titre2>
                          <Titre3 component='p'>
                            <Link
                              to={routes.ficheProducteur.replace(
                                ':id(\\d+)',
                                product.producerProfile.id
                              )}
                              className={classes.linkProducer}
                            >
                              {product.producerProfile.companyName}
                            </Link>
                          </Titre3>
                          {product.description && <p>{product.description}</p>}
                        </div>
                      </div>
                    </Fragment>
                  ))}
                  <hr className={classes.hrSeparator} />
                </div>
              ) : null
            })
          ) : (
            <Spinner />
          )}
        </Grid>
      </Grid>
      <Footer />
    </div>
  )
}

export default withStyles(styles)(PageProduit)
